import { createI18n } from "vue-i18n";
import Axios from 'axios';

// Create VueI18n instance with options
const i18n = createI18n({
    locale: 'nb', // set locale
    silentTranslationWarn: true // do not warn about missing texts
});

const resourceObjects = [
    'Modellregister'
];

Axios.post('/api/Language/GetResourcesForObjects', resourceObjects)
    .then((response) => {
        i18n.global.setLocaleMessage('nb', response.data);
    });

export default i18n;